"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearGradient = exports.hexColorString = exports.hexString = void 0;
function hexString(n) {
    return Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');
}
exports.hexString = hexString;
function hexColorString(color) {
    return `#${color.map(hexString).join('')}`;
}
exports.hexColorString = hexColorString;
function linearGradient(stops) {
    return `linear-gradient(${stops.join(',')})`;
}
exports.linearGradient = linearGradient;
